import { BehaviorSubject, type Observable } from "rxjs";

export abstract class State<T> {
  protected _observable: BehaviorSubject<T | null>;
  get observable(): Observable<T | null> {
    return this._observable.asObservable();
  }
  constructor(initialValue: T | null) {
    this._observable = new BehaviorSubject<T | null>(initialValue);
  }
  abstract clear(): void;
}
